<template>
  <div class="first_wrap">
    <div :style="{ paddingTop: pTop + 'px' }"></div>
    <div ref="img_box_ref" class="img_box">
      <div class="title hyphenate-text" :class="isTitleShow && 'active'">
        <span>{{ welcomeText }} </span>
      </div>
      <img v-if="gif" class="gif_banner" :src="gif" @load="imgLoad" />
      <div class="card_box" :class="isShow && 'active'">
        <div class="card_info">
          <div class="user_box">
            <img v-lazy="userHeadUrl" class="user_phone" alt="pic" />
            <p v-if="membership.cardNo">No.{{ membership.cardNo }}</p>
          </div>
          <div v-if="membership.enableDate" class="time_box">
            <div class="text">{{ addTimeText }}</div>
            <div class="time">{{ membership.enableDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="footer-container" :class="{ 'footer-container-tab': isFromTab }">
      <div class="btn-container">
        <rich-button @click="handleCk"> {{ $t('FoodC_update_mBwf_uAvp') }} </rich-button>
      </div>
    </div>
    <LoadingMask v-if="loading" />
  </div>
</template>

<script>
// import { gif } from '../imgs/base64'
import mixin from '@/page/member/mixins.js'
import LoadingMask from '@/components/loading/loading-mask.vue'

// 获取图片资源
async function loadImg() {
  try {
    const moduleInfo = await import('../imgs/base64')
    return moduleInfo
    // console.log(3333, moduleInfo.gif) // 假设JSON被解析为一个对象
  } catch (err) {
    console.error('load img error', err)
  }
}

export default {
  name: 'MemberFirstPage',
  components: {
    LoadingMask,
  },
  mixins: [mixin],
  data() {
    return {
      isShow: false,
      isTitleShow: false,
      gif: '',
      pTop: 90,

      loading: false,
    }
  },
  computed: {
    brandName() {
      return this.membership?.brandName
    },
    userHeadUrl() {
      const url = this.params?.userHeadUrl || ''
      return decodeURIComponent(url)
    },
    addTimeText() {
      return this.$t('FoodC_update_faXs_YHbq').toUpperCase()
    },
    welcomeText() {
      const text = this.$t('FoodC_update_TXai_tCJL', { brand: this.brandName }).toUpperCase()
      return text
    },
  },
  async mounted() {
    try {
      this.loading = true
      const pic = await loadImg()
      this.gif = pic?.gif || pic?.default?.gif || ''
      this.loading = false

      this.init()
    } catch (err) {
      this.loading = false
    }
  },
  methods: {
    init() {
      try {
        const winHeight = window?.innerHeight || 0
        if (winHeight > 700 && winHeight < 750) {
          this.pTop = 110
        } else if (winHeight >= 750 && winHeight < 800) {
          this.pTop = 130
        } else if (winHeight >= 800 && winHeight < 850) {
          this.pTop = 150
        } else if (winHeight >= 850 && winHeight < 100) {
          this.pTop = 170
        }
      } catch (err) {}
    },
    imgLoad() {
      setTimeout(() => {
        this.isShow = true
      }, 2000)
      setTimeout(() => {
        this.isTitleShow = true
      }, 1000)
    },
    handleCk() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.p_style {
  padding-top: 160px;
}
.first_wrap {
  width: 100%;
  min-height: 100vh;
  background: url('../imgs/succ_bg.png') no-repeat #ff4000;
  background-size: 100%;
}

.img_box {
  // margin-top: 20px;
  width: 750px;
  // height: 700px;
  height: 1100px;
  position: relative;
  .title {
    position: absolute;
    margin: 0 auto;
    width: 670px;
    left: calc(50% - 335px);
    top: 10px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    line-height: 70px;
    font-weight: normal;
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 0;
    transition: font-size 1s;
    opacity: 0; /* 初始透明度 */
    transition: opacity 1s ease-in-out; /* 过渡效果 */
    @include ellipsis(3);
    &.active {
      opacity: 1;
      font-size: 60px;
    }
  }
  .gif_banner {
    width: 750px;
    height: 1100px;
  }
}
.card_box {
  position: absolute;
  z-index: 10;
  width: 540px;
  height: 340px;
  border-radius: 20px;
  left: 102px;
  top: 400px;
  box-sizing: border-box;
  opacity: 0; /* 初始透明度 */
  transition: opacity 1s ease-in-out; /* 过渡效果 */
  &.active {
    opacity: 1;
  }
  .card_info {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .user_box {
    width: 100%;
    height: 80px;
    padding: 46px 0 20px 30px;
    .user_phone {
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    p {
      padding-top: 20px;
      height: 40px;
      font-family: DiDiSans-Pro-ExtraBold;
      font-size: 40px;
      color: #000000;
      line-height: 40px;
      font-weight: normal;
    }
  }
  .time_box {
    position: absolute;
    bottom: 20px;
    left: 30px;
    display: flex;
    min-height: 50px;
    background-color: #fffefe;
    .text {
      width: 70px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 16px;
      color: #89898c;
      text-align: right;
      line-height: 18px;
      font-weight: 500;
      margin-right: 10px;
    }
    .time {
      height: 40px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 32px;
      color: #000000;
      line-height: 40px;
      font-weight: 500;
    }
  }
}

.footer-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 8;
  width: 750px;
  // background: #ffffff;
  padding: 36px 24px 45px 24px;
  box-sizing: border-box;
  box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.04);
  border-radius: 40px 40px 0 0;
  .rich-btn {
    height: 120px;
    background: #fff;
    font-family: DiDiSans-Pro-ExtraBold;
    font-weight: normal;
    font-size: 48px;
    color: #ff5f14;
    border-radius: 40px;
  }
  &.footer-container-tab {
    padding-top: 16px;
    padding-bottom: 16px;
    .rich-btn {
      height: 104px;
      background: #fff;
      font-family: DiDiSans-Pro-ExtraBold;
      font-weight: normal;
      font-size: 40px;
      color: #ff5f14;
      border-radius: 32px;
    }
  }
}
</style>
